<app-processing [visible]="showProcessingDlg()"></app-processing>
<app-unsaved-changes-dialog [(visible)]="pageVars.showDirtyDlg"
  (decision)="dirtyConfirm($event)"></app-unsaved-changes-dialog>

<div class="flex justify-content-center">
  <p-card>
    <ng-template pTemplate="header">
      <p-breadcrumb [model]="pageVars.breadcrumbItems">
        <ng-template let-item let-last="last" let-first="first" pTemplate="item">
          <ng-container *ngIf="!first">
            <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
            <div *ngIf="!item.routerLink" class="breadcrumb-current-item">
              {{ item.label }}
            </div>
          </ng-container>
        </ng-template>
      </p-breadcrumb>
    </ng-template>

    <p-tabs [(value)]="tabValue" *ngIf="location.id !== emptyGuid">
      <p-tablist>
        <p-tab value="0" data-testid="tabInsects" (click)="tabPanelChange()">Insects</p-tab>
        <p-tab value="1" data-testid="tabSubstrates" (click)="tabPanelChange()">Substrates</p-tab>
        <p-tab value="2" data-testid="tabContainers" (click)="tabPanelChange()">Containers</p-tab>
        <p-tab value="3" data-testid="tabUndeliverable" (click)="tabPanelChange()">Configuration</p-tab>
        <p-tab value="4" data-testid="tabNotifications">Notifications</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <tab-insect *ngIf="catalog.id !== emptyGuid" [currentUser]="pageVars.currentUser" [catalogId]="catalog.id"
            [catalogInsects]="catalog.insects" (isReady)="tglTabsReady(0, $event)"></tab-insect>
        </p-tabpanel>
        <p-tabpanel value="1">
          <tab-substrate *ngIf="catalog.id !== emptyGuid" [currentUser]="pageVars.currentUser" [catalogId]="catalog.id"
            [catalogSubstrates]="catalog.substrates" [recipesLookup]="recipesLookup"
            [isRecipesLookupForbidden]="isRecipesLookupForbidden" (isReady)="tglTabsReady(1, $event)"></tab-substrate>
        </p-tabpanel>
        <p-tabpanel value="2">
          <tab-container #tabContainer *ngIf="catalog.id !== emptyGuid" [currentUser]="pageVars.currentUser"
            [catalogId]="catalog.id" (isReady)="tglTabsReady(2, $event)"></tab-container>
        </p-tabpanel>
        <p-tabpanel value="3">
          <p-accordion value="0">
            <p-accordion-panel value="1">
              <p-accordion-header>Settings</p-accordion-header>
              <p-accordion-content>
                <tab-orderitemtype *ngIf="catalog.id !== emptyGuid" [currentUser]="pageVars.currentUser"
                  [catalogId]="catalog.id" (isReady)="tglTabsReady(3, $event)"></tab-orderitemtype>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="2">
              <p-accordion-header>Undeliverable Dates</p-accordion-header>
              <p-accordion-content>
                <tab-undeliverable-dates *ngIf="location.id !== emptyGuid" [currentUser]="pageVars.currentUser"
                  [locationId]="location.id" (isReady)="tglTabsReady(3, $event)"></tab-undeliverable-dates>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="3">
              <p-accordion-header>Delivery Days (Recurring)</p-accordion-header>
              <p-accordion-content>
                <tab-delivery-days *ngIf="location.id !== emptyGuid" [currentUser]="pageVars.currentUser"
                  [locationId]="location.id" (isReady)="tglTabsReady(3, $event)"></tab-delivery-days>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="4">
              <p-accordion-header>Cost Centers</p-accordion-header>
              <p-accordion-content>
                <tab-projects *ngIf="location.id !== emptyGuid" (isReady)="tglTabsReady(3, $event)"
                  [currentUser]="pageVars.currentUser" [catalogId]="catalog.id"
                  [catalogProjects]="catalog.projects"></tab-projects>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="5">
              <p-accordion-header (click)="onPrintingAccordionClick()">Label Printing</p-accordion-header>
              <p-accordion-content>
                <tab-printing #tabPrinting *ngIf="location.id !== emptyGuid && printingTabLoaded"
                  [currentUser]="pageVars.currentUser" [locationId]="location.id" [catalogId]="catalog.id"
                  [siteCode]="catalog.siteCode" [catalog]="catalog" (isReady)="tglTabsReady(5, $event)"></tab-printing>
                <div *ngIf="!printingTabLoaded" class="text-center p-4">
                  <i class="pi pi-print mr-2"></i>
                  <span>Click to configure printing options for this site</span>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </p-tabpanel>
        <p-tabpanel value="4">
          <tab-notification *ngIf="catalog.id !== emptyGuid" [currentUser]="pageVars.currentUser"
            [catalogId]="catalog.id" [catalogWorkflowNotifications]="catalog.workflowNotifications"
            (isReady)="tglTabsReady(4, $event)"></tab-notification>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </p-card>
</div>